import "./primeDataGridStyle.css";

import { Box, useMediaQuery, useTheme } from "@mui/material";
import { GridRenderCellParams, GridRowSelectionModel } from "@mui/x-data-grid";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import { EnhancedButtonPrimeReactSeverity } from "../../common/Common";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { IAppState } from "../../store/reducers";
import { InputText } from "primereact/inputtext";
import { RequestParams } from "@websential/cosmic-v20";
import SearchIcon from "@mui/icons-material/Search";
import { SkeletonLoadingDataGrid } from "../SkeletonLoadingDataGrid";
import { useSelector } from "react-redux";

export interface IDataTable {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	showSettingColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: any) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	cardHeaderTitle?: string;
	cardHeaderSubTitle?: string;
	disabledHeaderTooltip?: boolean;
	viewIcon?: boolean;
	whiteSpace?: string;
	exportButton?: boolean;
	exportButtonLabel?: string;
	exportButtonInFileList?: boolean;
	onExportButtonClick?: (event: string, params: any) => void;
	onExportButtonInFileListClick?: (event: string, params: any) => void;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	t4Slip?: boolean;
}

export const PrimeDataGrid: React.FC<IDataTable> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	showSettingColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onSnackbarMessageData,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	cardHeaderTitle,
	cardHeaderSubTitle,
	disabledHeaderTooltip = false,
	viewIcon,
	whiteSpace,
	exportButton = false,
	exportButtonLabel = "file",
	exportButtonInFileList = false,
	onExportButtonClick,
	onExportButtonInFileListClick,
	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	t4Slip = false
}) => {
	const isInitialRequest = useRef(true);

	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));
	const densityClass = isMobile
		? "grid-density-mobile"
		: isSmallScreen
			? "grid-density-laptop"
			: isMediumScreen01
				? "grid-density-laptop"
				: "";


	const [loading, setLoading] = useState(false);
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedAuditEarningsItems, setSelectedAuditEarningsItems] =
		useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);

	// this is for select all option
	const [manualSelectAll, setManualSelectAll] = useState<any>(false);

	const setting = () => {
		return (
			<div>
				<i className="pi pi-cog text-xl"></i>
			</div>
		);
	};
	const editColumn = (params: any) => {
		return (
			<>
				<EnhancedButtonPrimeReact
					icon={"pi pi-pencil"}
					onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/>
			</>
		);
	};
	const delEdit = (params: any) => {

		return (
			<>
				{/* <EnhancedButtonPrimeReact
        icon={"pi pi-user-edit"}
        onClickHandler={() =>
          onRowEditClicked && onRowEditClicked(params)
        }
        severity={EnhancedButtonPrimeReactSeverity.Secondary}
        className="p-button-rounded p-button-text w-2rem h-2rem"
        rounded
      /> */}
				<EnhancedButtonPrimeReact
					icon="pi pi-times"
					onClickHandler={() =>
						onRowDeleteClicked && onRowDeleteClicked(params)
					}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					className={`p-button-rounded p-button-text w-2rem h-2rem ${isSmallScreen || isSmallScreen || isMediumScreen01 ? "ml-0" : "ml-2"}`}
					rounded
				/>
				{/* <Button
        icon={viewIcon ? "pi pi-eye" : "pi pi-user-edit"}
        onClick={() =>
          onRowEditClicked && onRowEditClicked(params)
        }
        className="p-button-rounded p-button-text w-2rem h-2rem"
      /> */}
				{/* <Button
        icon="pi pi-trash"
        onClick={() =>
          onRowDeleteClicked && onRowDeleteClicked(params)
        }
        className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
      /> */}
			</>
		);
	};
	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));


		// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
		if (onRequestParamsChange) {
			onRequestParamsChange({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				searchQuery: itemSearch,
				sortOrder: requestParams.sortOrder,
				sortField: requestParams.sortField,
			});
		}


		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));

		// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
		if (onRequestParamsChange) {
			onRequestParamsChange({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				searchQuery: "",
				sortOrder: requestParams.sortOrder,
				sortField: requestParams.sortField,
			});
		}

		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	// const onExportButtonClick = (event:any) => {
	//   if(event === 'XLS'){
	//     import('xlsx').then((xlsx) => {
	//       if(rows){
	//       const worksheet = xlsx.utils.json_to_sheet(selectedItems.length > 0 ? selectedItems : rows);
	//       const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
	//       const excelBuffer = xlsx.write(workbook, {
	//           bookType: 'xlsx',
	//           type: 'array'
	//       });

	//       saveAsExcelFile(excelBuffer, exportButtonLabel);
	//       }
	//   });
	//   } else if(event === 'CSV'){
	//     // dt.current.exportCSV(false);
	//     const csvData = generateCSVData(selectedItems.length > 0 ? selectedItems : rows);
	//     const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });

	//     const link = document.createElement('a');
	//     if (link.download !== undefined) {
	//       const url = URL.createObjectURL(blob);
	//       link.setAttribute('href', url);
	//       link.setAttribute('download', `${exportButtonLabel}.csv`);
	//       link.style.visibility = 'hidden';
	//       document.body.appendChild(link);
	//       link.click();
	//       document.body.removeChild(link);
	//     }
	//   } else if (event === 'PDF') {
	//     import('jspdf').then((jsPDF) => {
	//       const doc = new jsPDF.default();
	//       const data = selectedItems.length > 0 ? selectedItems : rows;

	//       // Adding table data
	//       let yOffset = 10; // Y position for table rows
	//       data.forEach((row: any, index: number) => {
	//         const rowData = Object.values(row).join(' | '); // Format row data as a string
	//         doc.text(rowData, 10, yOffset); // Add text to PDF
	//         yOffset += 10; // Adjust Y position for next row
	//       });

	//       doc.save(`${exportButtonLabel}.pdf`); // Save the PDF
	//     });
	//   }
	// }
	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					// justifyContent:showGlobalSearch ? "space-between" : "end",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div
					style={{
						fontSize: "1.5rem",
						fontWeight: "bold",
						fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
					}}
					className="title"
				>
					{pageTitle}
				</div>
				{showGlobalSearch && (
					<span
						className={`search p-input-icon-left ${isSmallScreen || isSmallScreen || isMediumScreen01 ? "" : "w-3"}`}
						style={{ display: "flex", marginLeft: "auto", height: "37px" }}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className={isSmallScreen || isSmallScreen || isMediumScreen01 ? "" : "w-full"}
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding:"8px 10px 8px 10px",
								padding: "10px 22px 10px 10px",
								fontSize: ".875rem",
								// marginRight:"-14px!important",
								borderRadius: "0px 2px 2px 0px",
								// backgroundColor: theme.palette.primary.main
							}}
						>
							{/* <SearchIcon /> */}
							Search
						</Button>
					</span>
				)}
				{/* {selectedItems.length > 0 ?
                        (
                          <>
                        <Button
                          icon="pi pi-trash"
                          onClick={() =>
                            onRowDeleteClicked(selectedItems)
                          }
                          severity="danger"
                        />
                          </>
                        ):(<></>)} */}

				{selectionToolbar && selectionToolbar(selectedItemsIds)}
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.clientName.props.children
						.toLowerCase()
						.indexOf(itemSearsch.toLowerCase()) > -1
			)
		);
	}
	// Custom column for row indices
	const indexColumn = {
		body: (rowData: any, row: any) => {
			return <span>{row.rowIndex + 1}</span>; // +1 to start indexing from 1 instead of 0
		},
		header: "#",
	};

	// const onPage = (event: any) => {
	// 	// setRequestParams(event);
	// 	setLoading(true);
	// 	//imitate delay of a backend call
	// 	setTimeout(() => {
	// 		setRequestParams({
	// 			...event,
	// 			searchQuery: itemSearch,
	// 		});
	// 		setLoading(false);
	// 	}, 1000);
	// };


	// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
	const onPage = (event: any) => {
		// setRequestParams(event);
		setLoading(true)
		//imitate delay of a backend call
		// setTimeout(() => {
		setRequestParams({
			...event,
			searchQuery: itemSearch,
		});
		if (onRequestParamsChange) {
			onRequestParamsChange({
				...event,
				searchQuery: itemSearch,
			});
		}
		//   setLoading(false);
		// }, 1000);
	};

	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				// Toggle sortOrder between 1 and -1
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				// Set the new sortField and reset sortOrder to 1
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}


			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
			if (onRequestParamsChange) {
				onRequestParamsChange({
					first: requestParams.first,
					page: requestParams.page,
					rows: requestParams.rows,
					searchQuery: requestParams.searchQuery,
					sortOrder: newSortOrder !== 1 ? "asc" : "desc",
					sortField: event.sortField,
				});
			}

			// Imitate delay of a backend call
			// setTimeout(() => {
			// 	setLoading(false);
			// }, 1000);
		},
		[sortOrder, sortField]
	);
	// This useEffect is triggered when the debouncedSearchQuery, pageSize or currentPage values change
	useEffect(() => {
		// if the results fetcher was passed, we can use it to fetch the results.
		if (onRequestParamsChange) {
			// skip the first initial call
			if (isInitialRequest.current === true) {

				isInitialRequest.current = false;
			} else {

				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});

		}

	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			let selectedItemsT4Ids = items.value.map((item: any) => item.provinceId);
			// setSelectedItems(selectedItemsIds);
			// Check for deleted items and remove them from selectedItems
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			const updatedSelectedT4Items = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.provinceId === selectedItem.provinceId);
			});
			setSelectedItems(t4Slip ? updatedSelectedT4Items : updatedSelectedItems);
			setSelectedAuditEarningsItems(t4Slip ? updatedSelectedT4Items : updatedSelectedItems);
			setSelectedItemsIds(t4Slip ? selectedItemsT4Ids : selectedItemsIds);

			// this is for select all option
			if (updatedSelectedItems.length !== rows?.length && rows?.length) {
				setManualSelectAll((prev: boolean) => prev && false);
			}

			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);
				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);
	useEffect(() => {
		// Check for deleted items and remove them from selectedItems
		const updatedSelectedItems =
			selectedItems &&
			selectedItems.length > 0 &&
			selectedItems.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
		// Only update if there are changes to selectedItems
		if (
			updatedSelectedItems &&
			updatedSelectedItems.length !== selectedItems.length
		) {
			setSelectedItems(updatedSelectedItems);

			// Update selectedItemsIds
			const updatedSelectedItemsIds = updatedSelectedItems.map(
				(item: any) => item.id
			);
			setSelectedItemsIds(updatedSelectedItemsIds);
		}

		// after update ignore tag in table then check whether new data is same as presvios selected items
		const updatedSelectedAuditEarningsItems =
			selectedAuditEarningsItems &&
			selectedAuditEarningsItems.length > 0 &&
			selectedAuditEarningsItems.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row === selectedItem);
			});
		// Only update if there are changes to selectedItems
		if (
			updatedSelectedAuditEarningsItems &&
			updatedSelectedAuditEarningsItems.length !== selectedItems.length
		) {
			setSelectedItems(updatedSelectedAuditEarningsItems);

			// Update selectedItemsIds
			const updatedSelectedAuditEarningsItemsIds =
				updatedSelectedAuditEarningsItems.map((item: any) => item.id);
			setSelectedItemsIds(updatedSelectedAuditEarningsItemsIds);
		}

	}, [rows, selectedItems, selectedAuditEarningsItems]);

	// this is for select all option
	const handleSelectAllCheckbox = useCallback(
		(e: any) => {
			const isSelectAllChecked = e.checked;

			const allRowsSelected = rows || [];
			alert(isSelectAllChecked ? "true" : "false");

			const allIds = allRowsSelected.map((item: any) => item.id);

			setManualSelectAll(isSelectAllChecked);
			setSelectedItems(isSelectAllChecked ? allRowsSelected : []);
			setSelectedAuditEarningsItems(isSelectAllChecked ? allRowsSelected : []);
			setSelectedItemsIds(isSelectAllChecked ? allIds : []);
			selectedRowsValues &&
				selectedRowsValues(isSelectAllChecked ? allRowsSelected : []);
		},

		[rows, selectedRowsValues]
	);

	const rowsWithTwoDecimalNumbersOnlyForEarningsAuditSreen =
		rows &&
		rows.map((item: any) => {
			return {
				...item,
				employmentIncome: parseFloat(item.employmentIncome)
					.toFixed(2)
					.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
				cppQppPensionableEarnings: parseFloat(item.cppQppPensionableEarnings)
					.toFixed(2)
					.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
				eiInsurableEarnings: parseFloat(item.eiInsurableEarnings)
					.toFixed(2)
					.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
			};
		});

	const paginatorLeft = showChecboxColumn ? (
		<div style={{ display: "flex", alignItems: "center", marginLeft: "-9px" }}>
			<Checkbox
				checked={manualSelectAll}
				onChange={(e) =>
					handleSelectAllCheckbox({ checked: e.target.checked })
				}
			></Checkbox>
		</div>
	) : undefined;



	// return isLoading ? (
	// 	<SkeletonLoadingDataGrid pageTitle={pageTitle} />
	// ) : (
	return (
		<>
			{/* {cardHeaderTitle ? (
				<Card
					title={cardHeaderTitle}
					subTitle={cardHeaderSubTitle}
					// footer={footer}
					className="mt-5"
				>
					<DataTable
						value={rows && rows}
						responsiveLayout="scroll"
						// lazy
						// filterDisplay="row"
						// dataKey="id"
						paginator
						// first={requestParams.first}
						rows={25}
						// totalRecords={totalRecords}
						// onPage={onPage}
						rowsPerPageOptions={rowsPerPageOptions}
						paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
						currentPageReportTemplate={`Showing {first} to {last} of {totalRecords} Items`}
						selection={selectedAuditEarningsItems}
						onSelectionChange={onSelectionModelChange}
						// editMode="row"
						selectionMode={"checkbox"}
						showGridlines
						resizableColumns
						columnResizeMode="expand"
						scrollable
						// scrollHeight="450px"
						// reorderableColumns
						// filterDisplay="menu"
						loading={isLoading}
						// globalFilterFields={["headerName"]}
						header={searchFieldPlaceholder ? headerSearch : undefined}
						footer={footer ? footer : undefined}
						emptyMessage="No Record found."
						className="primeDataGrid"
						style={{ margin: "14px 0.5rem 0.5rem 0.5rem" }}
						sortMode="single"
						onSort={onSort}
					>
						{columns && (
							<Column
								selectionMode="multiple"
								hidden={!showChecboxColumn}
								frozen
								resizeable={false}
								style={{ width: "36px", textAlign: "center" }}
								field="selection"
								columnKey="selection"
								className="selectionHeader"
								headerClassName="selectionHeader"
							></Column>
						)}
						{rows && (
							<Column
								header="#"
								className="indexColumn"
								headerStyle={{ width: "3rem" }}
								frozen
								hidden={!showIndexColumn}
								body={(data, options) => options.rowIndex + 1}
							></Column>
						)}

						{columns &&
							columns.map((x: any, index: any) => (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={disabledHeaderTooltip ? "" : x.description}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									sortable={x.sortable}
									resizeable={x.resizable}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									reorderable={x.disableReorder}
									exportable={x.disableExport}
									frozen={x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
									}}
									footer={x.footer}
								/>
							))}

						{rows && (
							<Column
								body={delEdit}
								header={setting}
								style={{ width: "85px" }}
								hidden={!showSettingColumn}
								resizeable={false}
								reorderable={false}
								frozen
								alignFrozen="right"
								className="settingHeader"
							></Column>
						)}
					</DataTable>
				</Card>
			) : ( */}
			<DataTable
				value={rows && rows}
				responsiveLayout="scroll"
				lazy
				// filterDisplay="row"
				paginator
				// paginatorLeft={
				// 	showChecboxColumn && columns && !columns.some((x: any) => x.footer !== null)
				// 		? paginatorLeft
				// 		: <div />
				// }
				// paginatorRight={<div />}
				first={requestParams.first}
				rows={requestParams.rows}
				totalRecords={totalRecords}
				onPage={onPage}
				rowsPerPageOptions={rowsPerPageOptions}
				paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
				currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				// editMode="row"
				// selectionMode={'checkbox'}
				selectionMode="multiple"

				// this is for select all option
				// dataKey="id"
				// selectAll={manualSelectAll}
				// onSelectAllChange={handleSelectAllCheckbox}

				showGridlines
				resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// scrollHeight="450px"
				// // reorderableColumns
				// filterDisplay="menu"
				// loading={isLoading ? isLoading : loading}
				// globalFilterFields={["headerName"]}
				emptyMessage={rows && rows.length === 0 ? "No Record Found." : "Loading..."}
				header={searchFieldPlaceholder ? headerSearch : undefined}
				footer={footer ? footer : undefined}
				// emptyMessage="No Record found."
				className={`primeDataGrid ${densityClass}`}
				style={{
					margin: `${tableMargin ? tableMargin : "14px 0.5rem 0.5rem 0"}`,
				}}
				sortMode="single"
				onSort={onSort}
			>
				{columns && rows && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					// footer={
					// 	showChecboxColumn && columns && columns.some((x: any) => x.footer !== null) ? (
					// 		<div style={{ display: "flex", alignItems: "center" }}>
					// 			<Checkbox
					// 				checked={manualSelectAll}
					// 				onChange={(e) =>
					// 					handleSelectAllCheckbox({ checked: e.target.checked })
					// 				}
					// 			></Checkbox>
					// 		</div>
					// 	) : undefined
					// }
					></Column>
				)}
				{rows && rows.length ? (
					<Column
						body={editColumn}
						// header={setting}
						style={{ width: isSmallScreen || isSmallScreen || isMediumScreen01 ? "24px" : "36px" }}
						hidden={!showSettingColumn}
						resizeable={false}
						reorderable={false}
						frozen
						// alignFrozen="right"
						// className="settingHeader"
						headerClassName="settingHeader"
					></Column>
				) : undefined}
				{rows && rows.length ? (
					<Column
						header="#"
						className="indexColumn"
						headerClassName="indexColumn"
						headerStyle={{ width: "24px" }}
						frozen
						hidden={!showIndexColumn}
						body={(data, options) => options.rowIndex + 1}
					></Column>
				) : undefined}

				{columns &&
					columns.map((x: any, index: any) => (
						<Column
							key={index}
							field={x.field}
							header={x.headerName}
							headerTooltip={disabledHeaderTooltip ? "" : x.description}
							headerTooltipOptions={{ position: "top" }}
							hidden={x.hide}
							sortable={x.sortable}
							// resizeable={x.resizable}
							dataType={x.type}
							align={x.align}
							alignHeader={x.headerAlign}
							reorderable={x.disableReorder}
							exportable={x.disableExport}
							frozen={x.frozenColumn}
							alignFrozen={x.alignFrozen}
							columnKey={x.field}
							style={{
								minWidth: x.minWidth,
								fontSize: "0.875rem",
							}}
							headerStyle={{ whiteSpace: whiteSpace ? whiteSpace : "nowrap" }}
							footer={x.footer}
						/>
					))}

				{rows && rows.length ? (
					<Column
						body={delEdit}
						// header={setting}
						style={{
							width: isSmallScreen || isSmallScreen || isMediumScreen01 ? "24px" : "36px",
							position: exportButtonInFileList ? "relative" : "sticky",
							overflow: exportButtonInFileList ? "visible" : "hidden",
						}}
						hidden={!showSettingColumn}
						resizeable={false}
						reorderable={false}
						frozen
						alignFrozen="right"
						className="settingHeader"
						headerClassName="settingHeader"
					></Column>
				) : undefined}
			</DataTable>
			{/* )} */}
		</>
	);
};

//resizeablbe must be false if frozen is true and viseversa
